import { ChevronDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PopoverTrigger } from "@/components/ui/popover";
import type { TagsTriggerProps } from "@/components/ui/shadcn-io/tags";
import { cn } from "@/lib/utils";

export const CustomTagsTrigger = ({
  className,
  children,
  title,
  ...props
}: TagsTriggerProps) => (
  <PopoverTrigger
    asChild
    className="w-full px-3 border border-gray-200 rounded-[6px] text-sm shadow-none bg-white pr-2 disabled:bg-gray-100 hover:bg-white cursor-pointer"
  >
    <Button
      className={cn("h-auto w-full justify-between p-2", className)}
      // biome-ignore lint/a11y/useSemanticElements: "Required"
      role="combobox"
      variant="outline"
      {...props}
    >
      <div className="flex flex-wrap items-center gap-1">
        {children}
        <span className="py-px text-gray-950">{title}</span>
      </div>
      <ChevronDown />
    </Button>
  </PopoverTrigger>
);
